import {Directive, Input, TemplateRef} from '@angular/core';
import {JdDyFormOptionItem} from "./dy-form.interface";

export class CustomLabelContext {
  constructor(public $implicit: JdDyFormOptionItem) {
  }
}

@Directive({
  selector: '[jdCustomLabelRef]'
})
export class CustomLabelDirective {

  @Input() jdCustomLabelRef: string;

  constructor(public templateRef: TemplateRef<CustomLabelContext>) {
  }

}
